import React, { useEffect, useState, useCallback } from 'react';
import { getAllCoaches } from '../../services/coachService';
import { getAllChatRooms, getAllCoachChatRooms } from '../../services/chatService';
import {
    Grid, Typography, Box
} from '@mui/material';
import CoachInfo from '../../components/coach/CoachInfo';
import LoadingPage from '../LoadingPage';
import { useSocket } from '../../context/SocketContext';
import ChatWindow from '../../components/chat/ChatWindow';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';

const CoachListPage = () => {
    const [coaches, setCoaches] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [chatRooms, setChatRooms] = useState([]);
    const { socket } = useSocket();
    const [openChatRooms, setOpenChatRooms] = useState([]);
    const [role, setRole] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const accessToken = localStorage.getItem('accessToken');
        let decoded = null;
        if (typeof accessToken === 'string' && accessToken) {
            try {
                decoded = jwtDecode(accessToken);
            } catch (e) {
                decoded = null;
            }
        }
        setRole(decoded?.role || null);
    }, []);

    useEffect(() => {
        if (role === 'coach') {
            navigate('/chat-page', { replace: true });
        }
    }, [role, navigate]);

    useEffect(() => {
        const fetchCoaches = async () => {
            try {
                setLoading(true);
                const data = await getAllCoaches();
                // Sort coaches by number of feedbacks 
                const sortedCoaches = (data.data || []).sort((a, b) => (b.feedbacks?.length || 0) - (a.feedbacks?.length || 0));
                setCoaches(sortedCoaches);
            } catch (err) {
                setError('Failed to fetch coaches.');
            } finally {
                setLoading(false);
            }
        };
        fetchCoaches();
    }, []);

    const fetchChatRooms = useCallback(async () => {
        try {
            let response;
            if (role === 'coach') {
                response = await getAllCoachChatRooms();
            } else {
                response = await getAllChatRooms();
            }

            console.log('Fetch chat rooms response:', response);

            // Handle different response structures
            let chatRoomsArray = [];
            if (response?.data?.data && Array.isArray(response.data.data)) {
                chatRoomsArray = response.data.data;
            } else if (response?.data && Array.isArray(response.data)) {
                chatRoomsArray = response.data;
            } else if (Array.isArray(response)) {
                chatRoomsArray = response;
            }

            console.log('Processed chat rooms array:', chatRoomsArray);
            setChatRooms(chatRoomsArray);
        } catch (e) {
            console.error('Error fetching chat rooms:', e);
            setChatRooms([]);
        }
    }, [role]);

    useEffect(() => {
        if (role) {
            fetchChatRooms();
        }
    }, [role, fetchChatRooms]);

    const handleCloseChat = (roomId) => {
        setOpenChatRooms((prev) => prev.filter(r => r.id !== roomId));
    };

    // Example: listen for new messages
    useEffect(() => {
        if (!socket) return;
        const handleNewMessage = (msg) => {
            // handle the new message
        };
        socket.on('newMessage', handleNewMessage);
        return () => {
            socket.off('newMessage', handleNewMessage);
        };
    }, [socket]);

    if (loading) {
        return (
            <LoadingPage />
        );
    }

    if (error) {
        return <Typography color="error" align="center" sx={{ mt: 8 }}>{error}</Typography>;
    }

    console.log('Current chatRooms state:', chatRooms);
    console.log('Chat rooms length:', chatRooms?.length);

    return (
        <Box sx={{ maxWidth: 1400, mx: 'auto', mt: 1, px: 2 }}>
            {/* <Typography variant="h4" fontWeight={700} gutterBottom align="center">
                Meet Our Coaches
            </Typography> */}
            <Box sx={{ mb: 4 }}>

                {/* {chatRoomsLoading ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <CircularProgress size={20} />
                        <Typography>Loading chat rooms...</Typography>
                    </Box>
                ) : Array.isArray(chatRooms) && chatRooms.length > 0 ? (
                    <Grid container spacing={2}>
                        {chatRooms.map(room => (
                            <Grid item xs={12} sm={6} md={4} key={room.id}>
                                <ChatRoom
                                    room={room}
                                    role={role}
                                    onOpenChat={() => handleOpenChat(room)}
                                />
                            </Grid>
                        ))}
                    </Grid>
                ) : (
                    <Box>
                        <Typography>No chat rooms found.</Typography>
                        <Typography variant="caption" color="text.secondary">
                            Role: {role || 'Not determined'} | Rooms count: {chatRooms?.length || 0}
                        </Typography>
                    </Box>
                )} */}
            </Box>
            <Box sx={{ position: 'fixed', bottom: 16, right: 16, display: 'flex', gap: 2, zIndex: 1300 }}>
                {openChatRooms.map(room => (
                    <ChatWindow
                        key={room.id}
                        room={room}
                        onClose={() => handleCloseChat(room.id)}
                    />
                ))}
            </Box>
            <Grid container spacing={4} justifyContent="center">
                {coaches.length === 0 && (
                    <Grid item xs={12}>
                        <Typography align="center">No coaches found.</Typography>
                    </Grid>
                )}
                {coaches.map((coach) => (
                    <Grid item xs={12} sm={8} md={6} key={coach.user_id}>
                        <CoachInfo coach={coach} />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default CoachListPage;